import React from 'react';

const SubjectsContext = React.createContext();

export default SubjectsContext;